import { ReactComponent as CameraIconSvg } from '../../assets/icons/mevo/ic_camera.svg';
import IconPattern, { IconProps } from './_IconPattern';

const CameraIcon: React.FC<IconProps> = (props) => {
  return <IconPattern component={CameraIconSvg} variantPlaces={[]} {...props} />;
};

export default CameraIcon;
